// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2no7j","approved":"Status_approved__1UOBM","rejected":"Status_rejected__HimtV","expired":"Status_expired__3_KQY","label":"Status_label__MTYc5"};